module.exports = __webpack_public_path__ + "static/media/AB_B6_3.e598af89.jpg";